import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 16v-8h4","key":"svg-1"}],["path",{"d":"M13 12h-3","key":"svg-2"}]]

const IconWashDryF = createReactComponent('outline', 'wash-dry-f', 'WashDryF', __iconNode);

export default IconWashDryF;